import { TypeSafeCollection } from '../classes/TypeSafeCollection';

const studyMetadataList = new TypeSafeCollection();

function add(studyMetadata) {
  studyMetadataList.insert(studyMetadata);
}

function get(studyInstanceUID) {
  return studyMetadataList.findBy({ studyInstanceUID });
}

function update(study, studyMetadata) {
  const { StudyInstanceUID } = study;
  if (!get(StudyInstanceUID)) add(studyMetadata);
}

function all(options) {
  return studyMetadataList.all(options);
}

function remove(studyInstanceUID) {
  studyMetadataList.remove({ studyInstanceUID });
}

function purge() {
  studyMetadataList.removeAll();
}

export default {
  add,
  get,
  update,
  all,
  remove,
  purge,
};
